import React from "react";
import { useTranslation } from "react-i18next";
import { GripVertical } from "lucide-react";
import { DraggableAttributes } from "@dnd-kit/core";
import { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";

interface DragHandleProps {
  attributes: DraggableAttributes;
  listeners: SyntheticListenerMap | undefined;
}

export const DragHandle = ({ attributes, listeners }: DragHandleProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "bulkMessaging.composeMessage",
  });

  return (
    <div className="flex flex-shrink-0 items-center self-center">
      <div
        {...attributes}
        {...(listeners || {})}
        className="cursor-move opacity-0 transition-opacity group-hover:opacity-100 hover:rounded hover:bg-muted"
        aria-label={t("dragHandle")}
      >
        <div className="flex h-6 w-6 items-center justify-center rounded">
          <GripVertical className="size-4 text-muted-foreground" />
        </div>
      </div>
    </div>
  );
};
